import { ReactElement } from 'react';

import { Leaves } from '@speeki/frontend-utils';
import { Palette } from '@speeki/theme';

import {
    AnimatedIcon,
    LoaderOverlay,
} from '@components/_universal/Loader/Loader.styled';

interface LoaderProps {
    children?: ReactElement | ReactElement[];
    className?: string;
    cogColor?: Leaves<Palette>;
    iconSize?: number;
    isFullScreen?: boolean;
    isLoading?: boolean;
    minHeight?: number;
    overlayColor?: Leaves<Palette>;
}

export const Loader = ({
    children,
    className,
    cogColor,
    iconSize,
    isFullScreen,
    isLoading,
    minHeight,
    overlayColor,
}: LoaderProps) => {
    return isLoading ? (
        <LoaderOverlay
            className={className}
            isFullScreen={isFullScreen}
            minHeight={minHeight}
            overlayColor={overlayColor}
        >
            <AnimatedIcon
                icon={'SvgLoader'}
                size={iconSize ? iconSize : 88}
                themeColors={{
                    default: { 'color-1': cogColor || 'neutral.darkGrey' },
                }}
            />
        </LoaderOverlay>
    ) : children ? (
        <>{children}</>
    ) : null;
};
